import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Card, Table, Space, Button, Input, Tag } from "antd";
import { EditUserDlg } from "../user/components/EditUserDlg";
import { UserLink } from "../../components/UserLink/UserLink";
import { fmtDateTime } from "../../common/Utils";
import { EditOutlined } from "@ant-design/icons";
import { AddUserDlg } from "./components/AddUserDlg";
import moment from "moment";
import { Store } from "../../store/Store";
import { observer } from "mobx-react";
import { userEditStore } from "../../store/user/UserEditStore";

export const OrgMembers = observer(() => {
  let { id } = useParams<any>();
  const store = Store.orgsStore.orgView;

  const edit = (id) => {
    userEditStore.edit(id);
  };
  const closeEdit = (refresh) => {
    if (refresh) store.loadMembers();
    userEditStore.close();
  };

  const closeAdd = (refresh) => {
    if (refresh) store.loadMembers();
    store.showAddUserDlg = false;
  };
  useEffect(() => {
    store.loadMembers();
  }, []);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Salutation",
      key: "title",
      dataIndex: "title",
      align: "center" as const,
    },
    {
      title: "Parent First Name",
      key: "firstName",
      align: "center" as const,
      sorter: (a, b) => a.firstName.localeCompare(b.firstName),
      render: (_, r) => <UserLink userId={r.id} name={r.firstName} fullName={r.name} />,
    },
    {
      title: "Parent Last Name",
      key: "lastName",
      align: "center" as const,
      sorter: (a, b) => a.lastName.localeCompare(b.lastName),
      render: (_, r) => <UserLink userId={r.id} name={r.lastName} fullName={r.name} />,
    },
    {
      title: "ID Verification",
      key: "idVerification",
      align: "center" as const,
      render: (_, r) =>
        !!r.profile && (
          <div>
            {r.profile.dlStatus === "Verified" && <Tag color="success">Driver’s License Verified</Tag>}
            {r.profile.dlStatus !== "Verified" && r.profile.idStatus === "Verified" && (
              <Tag color="success">ID Verified</Tag>
            )}
            {(r.profile.dlStatus === "ReviewNeeded" || r.profile.idStatus === "ReviewNeeded") && (
              <Tag color="warning">Need Review</Tag>
            )}
          </div>
        ),
    },
    {
      title: "App Status",
      dataIndex: "lastActivity",
      align: "center" as const,
      key: "lastActivity",
      sorter: (a, b) => moment(a.lastActivity).valueOf() - moment(b.lastActivity).valueOf(),
      render: (t, r) => `${t ? fmtDateTime(t) : "Inactive"}`,
    },
    {
      title: "App Avg. Rating",
      align: "center" as const,
      dataIndex: "appRate",
      sorter: (a, b) => a.appRate - b.appRate,
      key: "appRating",
    },
    {
      title: "User Avg. Rating",
      align: "center" as const,
      dataIndex: "userRate",
      key: "userRate",
      sorter: (a, b) => a.userRate - b.userRate,
    },
    {
      title: "Grade",
      align: "center" as const,
      dataIndex: "childGrades",
      key: "childGrades",
    },
    {
      title: "Invitation",
      align: "center" as const,
      dataIndex: "Invitation",
      key: "Invitation",
    },
    {
      key: "opt",
      align: "center" as const,
      render: (_, r) => (
        <Space>
          {/* <Button
            onClick={() => reInvitation()}
            type="primary"
            // disabled={user?.poolInfo?.status !== "FORCE_CHANGE_PASSWORD"}
          >
            Send Invitation
          </Button> */}
          {Store.isDivision ? null : <EditOutlined key="edit" onClick={() => edit(r.id)} />}
        </Space>
      ),
    },
  ];

  return (
    <Card
      size="small"
      bodyStyle={{ padding: 0 }}
      extra={
        <Space>
          {Store.isDivision ? null : (
            <Button size="small" onClick={() => (store.showAddUserDlg = true)}>
              Add User
            </Button>
          )}
          <Button loading={store.loadingMembers} size="small" onClick={() => store.loadMembers()}>
            Refresh
          </Button>
          <Input.Search size="small" value={store.keyword} onChange={(e) => (store.keyword = e.target.value)} />
        </Space>
      }
    >
      <Table
        size="small"
        loading={store.loadingMembers}
        rowKey="id"
        pagination={{ pageSize: 1500 }}
        columns={columns}
        dataSource={store.members}
      />
      {userEditStore.visible && <EditUserDlg onClose={closeEdit} />}
      {store.showAddUserDlg && <AddUserDlg orgId={id} onClose={closeAdd} />}
    </Card>
  );
});
